import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import client from "../../services/client";
import { ENDPOINTS } from "../../config";

const initialState = {
  token: null,
  status: "idle",
  error: null,
  message: null, // Store API messages here
  userInfo: null, // Store user info
};

export const fetchCredentials = createAsyncThunk(
  "auth/fetchCredentials",
  async (payload, thunkAPI) => {
    // debugger
    try {
      const response = await client.post(ENDPOINTS.login, payload);
      return response; // Adjust this based on your API response structure
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);


const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
   
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCredentials.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.message = null;
      })
      .addCase(fetchCredentials.fulfilled, (state, action) => {
        if (action.payload.responseCode === 200) {
          state.status = "succeeded";
          state.token = action.payload.data.token;
          state.userInfo = action.payload.data;
          state.message = action.payload.message;
          state.error = null;
        } else {
          state.status = "failed";
          state.error = action.payload.message || "Login failed.";
          state.token = null;
        }
      })
      .addCase(fetchCredentials.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || "Something went wrong.";
        state.message = action.payload?.message || "Something went wrong.";
      });
  },
});

export default authSlice.reducer;

